import StoreDeleteModal from './StoreDeleteModal'
export default StoreDeleteModal
